export default __webpack_public_path__ + "static/media/snd_00023.de4b8e08.mp4";